import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { AnimationMixer } from 'three'

export default class Soldier {
    constructor(_options) {
        this.scene = _options.scene
        this.resources = _options.resources
        this.time = _options.time
        this.config = _options.config

        this.container = new THREE.Object3D()

        this.loader = new GLTFLoader()
        this.loader.load('/models/Soldier.glb', (gltf) => {
            this.model = gltf.scene
            this.model.scale.set(1, 1, 1)
            this.container.add(this.model)

            // Position und Rotation
            this.model.position.set(2, 0, 0)
            this.model.rotation.y = Math.PI

            // Animation
            this.mixer = new AnimationMixer(this.model)
            this.animations = {
                Idle: this.mixer.clipAction(gltf.animations[0]),
                Run: this.mixer.clipAction(gltf.animations[1]),
                Walk: this.mixer.clipAction(gltf.animations[3]),
            }

            this.current = 'Idle'
            this.animations.Idle.play()

            this.time.on('tick', () => {
                this.mixer.update(this.time.delta)
                this.handleMovement()
            })
        })

        this.keys = {}
        window.addEventListener('keydown', (e) => { this.keys[e.code] = true })
        window.addEventListener('keyup', (e) => { this.keys[e.code] = false })
    }

    handleMovement() {
        if (!this.model) return

        let move = false
        let speed = 0.02

        if (this.keys['Digit1']) {
            this.switchAnimation('Idle')
        } else if (this.keys['Digit2']) {
            move = true
            this.switchAnimation('Walk')
            this.model.translateZ(speed)
        } else if (this.keys['Digit3']) {
            move = true
            this.switchAnimation('Run')
            this.model.translateZ(speed * 2)
        } else if (this.keys['Digit4']) {
            move = true
            this.switchAnimation('Run')
            this.model.translateX(speed * 2)
        }

        if (!move && this.current !== 'Idle') {
            this.switchAnimation('Idle')
        }
    }

    switchAnimation(name) {
        if (this.current === name) return
        this.animations[this.current]?.fadeOut(0.3)
        this.animations[name]?.reset().fadeIn(0.3).play()
        this.current = name
    }
}
